module.exports = __webpack_public_path__ + "media/Si.408a4f1a.wav";